module.exports = __webpack_public_path__ + "img/gengshifu-ios.ed5db342.png";